import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      class="footer-wrapper bg-title footer-layout5"
      data-bg-src="assets/img/bg/footer_bg_5.png"
    >
      <div class="widget-area">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-md-6 col-xxl-3 col-xl-4">
              <div class="widget footer-widget mb-0">
                <div class="th-widget-about">
                  <div class="about-logo">
                    <Link to="/">
                      <img src="assets/img/white_png_shreeji.png" style={{width:"90px"}} alt="shreeji_website "/>
                    </Link>
                  </div><br/>
                  <p class="about-text">
                   Shreeji is a convenience services to the adaptability, Spacious modern villa living room with centrally placed swimming pool blending indoor outdoor
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-auto">
              <div class="widget widget_nav_menu style2 footer-widget">
                <h3 class="widget_title">Company</h3>
                <div class="menu-all-pages-container">
                  <ul class="menu">
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/shop">All Products</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-auto">
              <div class="widget widget_nav_menu footer-widget">
                <h3 class="widget_title">Services</h3>
                <div class="menu-all-pages-container">
                  <ul class="menu">
                    <li>
                      <Link to="/wishlist">Wishlist</Link>
                    </li>
                    <li>
                      <Link to="/account">My Account</Link>
                    </li>                    
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-auto">
              <div class="widget widget_nav_menu footer-widget">
                <h3 class="widget_title">Customer Care</h3>
                <div class="menu-all-pages-container">
                  <ul class="menu">
                    <li>
                      <Link to="/account">My account</Link>
                    </li>
                    <li>
                      <Link to="/wishlist">Wish List</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact us</Link>
                    </li>
                   
                  </ul>
                </div>
              </div>
            </div>            
          </div>
        </div>
        <div class="container">
          <div class="row justify-content-end align-items-end">
            <div class="col-xl-4">
              <div class="footer-widget-about">
                <div class="th-widget-about">
                  <p class="footer-info">
                    <i class="fa-sharp fa-solid fa-phone"></i>
                    <span>
                      <Link class="text-inherit" to="tel:+009879793195">
                        +91-9879793195
                      </Link>
                    </span>
                  </p>
                  <p class="footer-info">
                    <i class="fa-sharp fa-solid fa-envelope"></i>
                    <span>
                      <Link
                        class="text-inherit"
                        to="mailto:info@shreejimeditechsystems.com"
                      >
                        info@shreejimeditechsystems.com
                      </Link>
                    </span>
                  </p>
                  <p class="footer-info">
                    <i class="fas fa-map-marker-alt"></i>Sardar Patel Ringroad, Zundal, Ahmedabad
                  </p>
                </div>
              </div>
            </div>
            <div class="col-xl-8">
              <div class="row gy-4 align-items-center">
                <div class="col-lg-12">
                  <div class="title-area mb-0 text-center text-lg-start">
                    <h4 class="sec-title text-white m-0">
                      Explore Our Comprehensive Healthcare Solutions
                    </h4>
                  </div>
                </div>               
              </div>
            </div>
          </div>
        </div>
        <div class="copyright-wrap">
          <div class="container">
            <div class="row gy-2 align-items-center">
              <div class="col-lg-12">
                <p class="copyright-text" style={{textAlign:"center"}}> Copyright 2025 &nbsp;|&nbsp;
                  <Link to="/">Shreeji Meditech Systems</Link>. Design & Developed by Adi Tech.
                </p>               
              </div>
              <div class="col-lg-7 text-center text-lg-end">
                <div class="social-links">
                  <span class="title">Social Media:</span>
                  <Link to="https://www.facebook.com/">
                    <i class="fab fa-facebook-f"></i>
                  </Link>
                  <Link to="https://www.twitter.com/">
                    <i class="fab fa-twitter"></i>
                  </Link>
                  <Link to="https://www.linkedin.com/">
                    <i class="fab fa-linkedin-in"></i>
                  </Link>
                  <Link to="https://www.whatsapp.com/">
                    <i class="fab fa-whatsapp"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="heart-rate2" data-bg-src="assets/img/shape/preloader3.svg"  style={{ backgroundImage: `url('assets/img/shape/preloader3.svg')` }}>
        {" "}
      </div>
      <div class="heart-rate" data-bg-src="assets/img/shape/preloader2.svg"  style={{ backgroundImage: `url('assets/img/shape/preloader2.svg')` }}>
        <div class="fade-in"></div>
        <div class="fade-out"></div>
      </div>
    </footer>
  );
}
